import {useEffect, useRef, useState} from "react";

import "@styles/components/calendar.scss";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import moment from "moment/min/moment-with-locales";
import Calendar from "react-calendar";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const DropCalendar = ({
  date,
  setDate,
  minDate = new Date(),
  format = "DD-MM-YYYY",
  monthYearOnly = false,
  isFrom = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {language} = useSelector((state) => state.common.settings);

  const calendarRef = useRef(null);

  const toggleSelect = () => {
    setIsOpen(!isOpen);
  };

  const handleChangeDate = (currentDate) => {
    if (monthYearOnly) {
      if (isFrom) {
        setDate(moment(currentDate).startOf("month").toDate());
      } else {
        setDate(moment(currentDate).endOf("month").toDate());
      }
    } else {
      setDate(currentDate);
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={calendarRef}
      className={styles.calendarWrapper}
    >
      <div
        onClick={toggleSelect}
        className={styles.calendarHead}
      >
        <RootDesc>
          <span>
            {monthYearOnly
              ? moment(date).format("MMMM YYYY")
              : moment(date).format(format)}
          </span>
        </RootDesc>

        <i
          style={
            isOpen ? {transform: "rotate(180deg)"} : {transform: "rotate(0deg)"}
          }
        />
      </div>

      {isOpen && (
        <div className={styles.calendar}>
          <BorderArticle>
            <Calendar
              minDate={minDate}
              locale={language}
              onChange={(currentDate) => handleChangeDate(currentDate)}
              value={date}
              {...(monthYearOnly && {
                view: "year",
                maxDetail: "year",
                minDetail: "year",
              })}
            />
          </BorderArticle>
        </div>
      )}
    </div>
  );
};
